export default "__VITE_ASSET__5d6cb5bb__"